module.exports = __webpack_public_path__ + "img/full_icon.652e9466.png";